import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/lib/services/settings';
import { resolveCurrencyName } from '@/lib/rewardsCurrency';

/**
 * What this store calls its reward points ("CFAdollars" unless the store
 * renamed them). Falls back to the default while settings load, which is
 * also every store's default. Reads the same cached query as useRewardsSystem.
 */
export function useRewardsCurrency(): string {
  const { data: settings } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000,
  });
  return resolveCurrencyName(settings);
}
